import React, { useState, useEffect } from 'react'
import { Button, Card, Collapse, Form, Modal, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import './purchaseList.scss'
import SkeletonTableRow from '../../../component/skeletonTableRow/skeletonTableRow';
import PaginationAndSearching from '../../../component/paginationAndSearching/paginationAndSearching';
import { lblEnterProblemDescription, txtCategory, txtCreatedBy, txtDateTime, txtServiceID, txtServiceRequests, txtStatus } from '../../../dataBaseFile/label';
import { btnAvailableServices, btnMyServices, btnOpenJobs } from '../../../dataBaseFile/alert';
import { getPurchaseList } from '../../../service/api/ticket/getPurchaseList';
import PrimaryButton from '../button/primaryButton';
import InputField from '../fields/inputField';
import TextArea from '../fields/textArea';
import { createPurchaseItem } from '../../../service/api/ticket/createPurchaseItem';
import ResponceToaster from '../responceToaster/responceToaster';
import updatePurchaseItem from '../../../service/api/ticket/updatePurchaseItem';
import deletePurchaseItem from '../../../service/api/ticket/deletePurchaseItem';
import { emailValidation, noSpaceOnChange, phoneValidation } from '../../../functions/validations';
import EmailPhoneCombine from '../fields/emailPhoneField';
import { validEmail_OR_MobileNumberText, validMobileNumberText } from '../../../dataBaseFile/error';
import sharePurchaseList from '../../../service/api/ticket/sharePurchaseList';

const PurchaseList = ({ purchaseListTrigger, ticketDisplayName, handleClosePurchaseList, categoryForPurchase, messageForPurchase }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [page, setPage] = React.useState(1)
    const [pageSize, setPageSize] = useState(25)
    const [totalPage, setTotalPage] = useState(1)
    const [sortByValue, setSortByValue] = useState('DESC')
    const [searchValue, setSearchValue] = useState('')
    const [bulkDeleteArr, setBulkDeleteArr] = useState([])
    const [skeltonVal, setSkeltonVal] = useState(false)
    const [columnName, setColumnName] = useState("")
    const [totalNoRecord, setTotalNoRecord] = useState(100)
    const [elements, setElements] = useState([]);
    const [customeSkeletonLoaing, setCustomeSkeletonLoaing] = useState(false)

    const [flag, setFlag] = useState(false);


    const [currentTimeString, setCurrentTimeString] = useState("");
    const [toggleForPurchase, setToggleForPurchase] = useState(1);

    const [purchaseItemId, setPurchaseItemId] = useState();
    const [itemName, setItemName] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [totalEstimatedCost, setTotalEstimatedCost] = useState(0);
    const [purchaseLink, setPurchaseLink] = useState("");
    const [itemDescription, setItemDescription] = useState("");

    const [itemNameErr, setItemNameErr] = useState(false);
    const [quantityErr, setQuantityErr] = useState(false);
    const [totalEstimatedCostErr, setTotalEstimatedCostErr] = useState(false);
    const [purchaseLinkErr, setPurchaseLinkErr] = useState(false);
    const [itemDescriptionErr, setItemDescriptionErr] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);

    const [purchaseLoading, setPurchaseLoading] = useState(false);
    const [totalCost, setTotalCost] = useState(0);

    const rows = elements

    const handleChangeRowsPerPage = (e) => {
        setSearchValue('')
        setPage(1)
        setPageSize(e.target.value)
    }

    // console.log(rows, "rows")


    const getCallHistoryDetails = (res) => {
        // console.log(res, "Res")
        setElements(res.data.data)
        setTotalNoRecord(res.data.total_count)
        setTotalCost(res.data?.total_estimated_cost)
        if (res.data.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.data.total_count / pageSize))
        } else {
            setTotalPage(parseInt(res.data.total_count / pageSize + 1))
        }

        if (res.data.total_count === 0) {
            setTimeout(() => {
                setSkeltonVal(true)
            }, '3000')
        } else {
            setSkeltonVal(true)
        }
        // console.log(parseInt(res.total_records / pageSize), 'quoitent')
    }

    function getCurrentDateTime() {
        const now = new Date();

        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        return now.toLocaleString('en-US', options);
    }

    function encodeDateString(currentTimeString) {
        return encodeURIComponent(currentTimeString);
    }

    useEffect(() => {
        setCurrentTimeString(getCurrentDateTime());
    }, [])




    const onLoadData = () => {
        setCustomeSkeletonLoaing(true);

        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem('user_id'));
        data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
        data.append("generated_date_dtm", getCurrentDateTime());
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        dispatch(
            getPurchaseList(data, (res) => {
                getCallHistoryDetails(res);
                setCustomeSkeletonLoaing(false);
            })
        )

    }



    const handleSorting = (e) => {
        if (e.target.value === 'Latest') {
            setSortByValue('DESC')
        } else {
            setSortByValue('ASC')
        }
    }

    const onChangePage = (e, p) => {
        // setPage(p)
        setPage(e);
    }
    // console.log(page, "page")

    const handleSearch = (e) => {
        // setPage(1)
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
            setColumnName('')
        }
        setSearchValue(e.target.value)
    }

    const handleOrderValue = (order) => {
        setSortByValue(order)
    }

    const handleColumnName = (name) => {
        setSortingCol(false);
        setColumnName(name)
        if (sortByValue === "ASC") {
            setSortByValue("DESC")
        }
        if (sortByValue === "DESC") {
            setSortByValue("ASC")
        }

    }

    useEffect(() => {

        onLoadData()
    }, [sortByValue, pageSize, page, columnName])

    function onLoadSearch() {
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem('user_id'));
        data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
        data.append("generated_date_dtm", getCurrentDateTime());
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        dispatch(
            getPurchaseList(data, (res) => {
                getCallHistoryDetails(res);
                setCustomeSkeletonLoaing(false);
            })
        )
    }

    useEffect(() => {
        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(onLoadSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValue]);

    const [sortingCol, setSortingCol] = useState(true);


    const tooltipDelete = (
        <Tooltip id="tooltip">
            <strong>Delete</strong>
        </Tooltip>
    );
    const tooltipEdit = (
        <Tooltip id="tooltip">
            <strong>Edit</strong>
        </Tooltip>
    );
    const tooltipDownload = (
        <Tooltip id="tooltip" >
            <strong >Download Shopping List</strong>
        </Tooltip>
    );
    const tooltipAddShoppingItem = (
        <Tooltip id="tooltip" >
            <strong >Add Shopping Item</strong>
        </Tooltip>
    );
    const sharePurchaseListToolTip = (
        <Tooltip id="tooltip" >
            <strong >Share Shopping List</strong>
        </Tooltip>
    );
    const tooltipCopyTxt = (
        <Tooltip id="tooltip">
            <strong>Copy to clipboard</strong>
        </Tooltip>
    );

    const handleCreatePurchaseList = () => {
        setToggleForPurchase(2)
    }

    const handleEditPurchaseList = (e) => {
        e?.stopPropagation();
        setToggleForPurchase(3)
    }

    const handleItemName = (e) => {
        setItemNameErr(false);
        setItemName(e.target.value)
    }

    const handleQuantity = (e) => {
        setQuantityErr(false);
        setQuantity(e.target.value.replace(/\D/g, ''))
    }

    const handleTotalEstimatedCost = (e) => {
        setTotalEstimatedCostErr(false);
        setTotalEstimatedCost(e.target.value.replace(/[^\d.]/g, '').replace(/(\.\d*)\./g, '$1'))
    }

    const handlePurchaseLink = (e) => {
        setPurchaseLinkErr(false);
        setPurchaseLink(e.target.value)
    }

    const handleDescription = (e) => {
        setItemDescriptionErr(false);
        setItemDescription(e.target.value);
    }

    const handleItemNameBlurCheck = () => {
        if (itemName === '') {
            setItemNameErr(true)
        }
    }

    const handleQuantityBlurCheck = () => {
        if (isNaN(quantity) || quantity === '') {
            setQuantityErr(true)
        }
    }

    const handleTotalEstimatedCostBlurCheck = () => {
        if (isNaN(totalEstimatedCost) || totalEstimatedCost === '') {
            setTotalEstimatedCostErr(true)
        }
    }

    const handlePurchaseLinkBlurCheck = () => {
        if (purchaseLink === '') {
            setPurchaseLinkErr(true)
        }
    }

    const handleDescriptionBlurCheck = () => {
        if (itemDescription === '') {
            setItemDescriptionErr(true)
        }
    }


    const handleSubmitPurchase = (e) => {
        e.preventDefault();

        if (itemName === '') {
            setItemNameErr(true)
        }
        // if (quantity === '') {
        //     setQuantityErr(true)
        // }
        // if (totalEstimatedCost === '') {
        //     setTotalEstimatedCostErr(true)
        // }
        // if (purchaseLink === '') {
        //     setPurchaseLinkErr(true)
        // }
        // if (itemDescription === '') {
        //     setItemDescriptionErr(true)
        // }

        if (itemName) {
            // console.log(itemName, quantity, totalEstimatedCost, purchaseLink, itemDescription)
            setPurchaseLoading(true)

            let data = new FormData();
            data.append("user_id_ids", localStorage.getItem('user_id'));
            data.append("call_log_id_ids", localStorage.getItem('call_log_id') || "");
            data.append("ticket_id_ids", localStorage.getItem('ticket_id') || "");
            data.append("item_name_chr", itemName);
            data.append("quantity_int", quantity == "" ? 0 : quantity);
            data.append("estimated_price_float", parseFloat((quantity * totalEstimatedCost).toFixed(2)));
            data.append("description_chr", itemDescription);
            data.append("purchase_link_chr", purchaseLink);

            dispatch(
                createPurchaseItem(data, (res) => {
                    setPurchaseLoading(false)
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    setToggleForPurchase(1);

                    handleCloseCreatePurchaseItem();

                    onLoadData();

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);

                }, (err) => {
                    setPurchaseLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            )

        }
    }

    const handleCloseCreatePurchaseItem = (e) => {
        e?.preventDefault();
        setToggleForPurchase(1)
        setItemNameErr(false);
        setQuantityErr(false);
        setTotalEstimatedCostErr(false);
        setPurchaseLinkErr(false);
        setItemDescriptionErr(false);

        setItemName('');
        setQuantity(0);
        setTotalEstimatedCost(0);
        setPurchaseLink('');
        setItemDescription('');

        setEmailPhoneValue('')
        setIsEmailPhoneVal(false);
    }

    const handleUpdatePurchaseList = (element, e) => {
        e.stopPropagation();

        // setPurchaseLoading(true)

        setPurchaseItemId(element?.item_id_ids)
        setItemName(element?.item_name_chr)
        setQuantity(element?.quantity_int)
        setTotalEstimatedCost(((element?.estimated_price_float) / (element?.quantity_int)).toFixed(2))
        setPurchaseLink(element?.purchase_link_chr)
        setItemDescription(element?.description_chr)
        setToggleForPurchase(3)
    }

    const handleViewPurchaseItem = (element) => {
        setPurchaseItemId(element?.item_id_ids)
        setItemName(element?.item_name_chr)
        setQuantity(element?.quantity_int)
        setTotalEstimatedCost(element?.estimated_price_float)
        setPurchaseLink(element?.purchase_link_chr)
        setItemDescription(element?.description_chr)
        setToggleForPurchase(5)
    }

    const handleDeletePurchaseList = (element, e) => {
        e.stopPropagation();
        setPurchaseLoading(true)

        setPurchaseItemId(element?.item_id_ids)

        let details = {
            user_id_ids: localStorage.getItem('user_id'),
            item_id_ids: element?.item_id_ids,
        };

        dispatch(
            deletePurchaseItem(details, (res) => {
                setPurchaseLoading(false)
                setResponceMsg(res.data.message)
                setToasterType("success")

                onLoadData();

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }, (err) => {
                setPurchaseLoading(false)
                setResponceMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }

    const handleUpdatePurchase = (e) => {
        e.preventDefault();

        if (itemName === '') {
            setItemNameErr(true)
        } else {
            setPurchaseLoading(true)
            let data = new FormData();
            data.append("user_id_ids", localStorage.getItem('user_id'));
            data.append("item_id_ids", purchaseItemId);
            data.append("call_log_id_ids", localStorage.getItem('call_log_id'));
            data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
            data.append("item_name_chr", itemName);
            data.append("quantity_int", quantity == "" ? 0 : quantity);
            data.append("estimated_price_float", parseFloat((quantity * totalEstimatedCost).toFixed(2)));
            data.append("description_chr", itemDescription);
            data.append("purchase_link_chr", purchaseLink);

            dispatch(
                updatePurchaseItem(data, (res) => {
                    setPurchaseLoading(false)
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    setToggleForPurchase(1);

                    handleCloseCreatePurchaseItem();

                    onLoadData();

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }, (err) => {
                    setPurchaseLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            )
        }
    }

    // Send purchase list via email or phone number

    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState(1);
    const [isPhone, setIsPhone] = useState(false);


    const handleSendPurchaseList = (e) => {
        e.preventDefault();
        if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
            setPurchaseLoading(true);
            if (isPhone) {
                const data = new FormData();
                data.append("user_id_ids", localStorage.getItem("user_id"))
                data.append("ticket_id_ids", localStorage.getItem('ticket_id'))
                data.append("generated_date_dtm", getCurrentDateTime());
                data.append("email_chr", "");
                data.append("phone_code_id_int", parseInt(codeValue) || 1);
                data.append("phone_number_int", emailPhoneValue);

                dispatch(
                    sharePurchaseList(data, (res) => {
                        setPurchaseLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("success")
                        setToggleForPurchase(1);

                        handleCloseCreatePurchaseItem();

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }, (err) => {
                        setPurchaseLoading(false)
                        setResponceMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );
            } else if (!isPhone) {

                const data = new FormData();
                data.append("user_id_ids", localStorage.getItem("user_id"))
                data.append("ticket_id_ids", localStorage.getItem('ticket_id'))
                data.append("generated_date_dtm", getCurrentDateTime());
                data.append("email_chr", emailPhoneValue);
                // data.append("phone_code_id_int", null);
                // data.append("phone_number_int", null);

                dispatch(
                    sharePurchaseList(data, (res) => {
                        setPurchaseLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("success")
                        setToggleForPurchase(1);

                        handleCloseCreatePurchaseItem();

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }, (err) => {
                        setPurchaseLoading(false)
                        setResponceMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );

            }
        } else {
            setIsEmailPhoneVal(true);
        }
    };

    const handleEmailPhone = (e) => {
        setIsEmailPhoneVal(false);

        noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
    };
    const handleDropdownValue = (e) => {
        // setCodeValue(e.target.value);
        setCodeValue(e);
    };

    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }
    }, [emailPhoneValue]);

    function handleEmailPhoneBlur() {
        if (isPhone) {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        } else {
            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        }
    }

    const copyToClipboard = () => {
        setResponceMsg("Link copied to clipboard!");
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 11000);
    }

    // Format the price to USD 
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade" show={purchaseListTrigger} size={toggleForPurchase === 1 ? 'lg' : 'sl'}
            // onHide={handleClose} 
            >
                <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title style={{ display: 'flex', }}>
                        {toggleForPurchase !== 1 && <i onClick={(e) => handleCloseCreatePurchaseItem(e)} style={{ marginRight: '10px', cursor: 'pointer', fontSize: '18px' }} className="bi bi-arrow-left "></i>}
                        {toggleForPurchase === 1 ? "Shopping List" :
                            toggleForPurchase === 2 ? "Shopping List" :
                                toggleForPurchase === 3 ? "Edit Shopping Item" :
                                    toggleForPurchase === 4 ? "Share Shopping List" :
                                        toggleForPurchase === 5 ? "Purchase Item Details" : ""}
                    </Modal.Title>
                    <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={() => handleClosePurchaseList()}
                    >

                    </Button>
                </Modal.Header>
                <Modal.Body>

                    {toggleForPurchase === 1 ?
                        <>
                            <div style={{ color: 'black' }}>
                                <p style={{ marginBottom: '0px', fontSize: '16px' }}><strong>Service Id : {ticketDisplayName}</strong></p>
                                {categoryForPurchase && <p style={{ marginBottom: '0px' }}>{`${categoryForPurchase}`} {messageForPurchase && `: ${messageForPurchase}`}</p>}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: '15px' }}>
                                <div>
                                    <OverlayTrigger placement="top" overlay={tooltipAddShoppingItem}>
                                        <Button onClick={() => handleCreatePurchaseList()} className="notification-btn attachment-btn" variant="primary" >
                                            <i style={{ fontSize: '21px' }} className="bi bi-plus-lg"></i>
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                                {rows.length > 0 &&
                                    <>
                                        <div style={{ marginLeft: '10px' }}>
                                            <OverlayTrigger placement="top" overlay={tooltipDownload}>
                                                <div>
                                                    <a download href={process.env.REACT_APP_BASE_URL + `ServiceRequest/DownloadPurchaseList?user_id_ids=${localStorage.getItem('user_id')}&ticket_id_ids=${localStorage.getItem('ticket_id')}&generated_date_dtm=${encodeDateString(currentTimeString)}`} target='_blank' rel="noreferrer noopen">
                                                        <Button className="notification-btn attachment-btn" variant="primary" >
                                                            <i style={{ fontSize: '21px' }} className="bi bi-file-earmark-arrow-down-fill"></i>
                                                        </Button>
                                                    </a>
                                                </div>
                                            </OverlayTrigger>
                                        </div>

                                        <div style={{ marginLeft: '10px' }}>
                                            <OverlayTrigger placement="top" overlay={sharePurchaseListToolTip}>
                                                {/* <a download href={process.env.REACT_APP_BASE_URL + `Ticket/DownloadPurchaseList?user_id_ids=${localStorage.getItem('user_id')}&ticket_id_ids=${localStorage.getItem('ticket_id')}&generated_date_dtm=${encodeDateString(currentTimeString)}`}> */}
                                                <Button onClick={() => { setToggleForPurchase(4) }} className="notification-btn attachment-btn" variant="primary" >
                                                    <i style={{ fontSize: '21px' }} className="bi bi-send-check-fill"></i>
                                                </Button>
                                                {/* </a> */}
                                            </OverlayTrigger>
                                        </div>
                                    </>

                                }
                            </div>

                            {rows.length > 0 &&
                                <div className='purchase-list-total-cost'>
                                    <p style={{ marginBottom: '0px' }}><span style={{ fontWeight: '600' }}>Items:</span> {rows.length}</p>
                                    {totalCost && <p style={{ marginBottom: '0px' }}><span style={{ fontWeight: '600' }}>Total Cost:</span> {USDollar.format(parseFloat(totalCost.toFixed(2)))}</p>}
                                </div>}


                            {/* <PaginationAndSearching
                                handleSearch={handleSearch}
                                searchValue={searchValue}
                                defaultValue={pageSize}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                                totalCount={totalPage}
                                onChange={onChangePage}
                            /> */}

                            {/* <Table responsive>

                                <thead style={{ background: '#8080801c', }}>
                                    <tr>


                                        <th style={{ cursor: 'pointer', }}>
                                            <div className='d-flex align-items-center' onClick={() => { handleColumnName("item_name_chr") }}>
                                                <strong>{"Item Name"}</strong>
                                                {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}

                                                {sortByValue === "DESC" && columnName === "item_name_chr" && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                                                {sortByValue === "ASC" && columnName === "item_name_chr" && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                                            </div>

                                        </th>
                                        <th style={{ cursor: 'pointer' }}>
                                            <div className='d-flex align-items-center' onClick={() => { handleColumnName("description_chr") }}>
                                                <strong>{lblEnterProblemDescription}</strong>
                                                {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}

                                                {sortByValue === "DESC" && columnName === "description_chr" && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                                                {sortByValue === "ASC" && columnName === "description_chr" && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                                            </div>

                                        </th>

                                        <th style={{ cursor: 'pointer' }}>
                                            <div className='d-flex align-items-center' onClick={() => { handleColumnName("updated_date_dtm") }}>
                                                <strong >{"Updated On"} </strong>
                                                {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}

                                                {sortByValue === "DESC" && columnName === "updated_date_dtm" && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                                                {sortByValue === "ASC" && columnName === "updated_date_dtm" && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                                            </div>

                                        </th>

                                        <th style={{ cursor: 'pointer' }}>
                                            <div className='d-flex align-items-center'>
                                                <strong >{"Actions"} </strong>

                                            </div>

                                        </th>

                                    </tr>
                                </thead>

                                <tbody>

                                    {customeSkeletonLoaing ?
                                        <SkeletonTableRow cols={4} rows={5} /> :

                                        <>
                                            {rows.length > 0 ?
                                                <>
                                                    {
                                                        rows.map((element, index) => {
                                                            return (
                                                                <>
                                                                    <tr key={index} onClick={(e) => { handleViewPurchaseItem(element) }} className='notification-rows' style={{ fontSize: '13px' }}>
                                                                        <td style={{ borderTopLeftRadius: '20px !important', borderBottomLeftRadius: '20px !important', }}>
                                                                            {element.item_name_chr ? element.item_name_chr : 'NA'}
                                                                        </td>

                                                                        <td >
                                                                            <span className='global-text-overflow'>
                                                                                {element.description_chr ? element.description_chr : 'NA'}
                                                                            </span>
                                                                        </td >



                                                                        <td>
                                                                            <div className='d-flex' style={{ flexDirection: 'column' }}>
                                                                                <div>
                                                                                    {(new Date(element?.updated_date_dtm * 1000)).toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric', })}
                                                                                </div>

                                                                            </div>
                                                                        </td>

                                                                        <td>
                                                                            <div className='d-flex' style={{ justifyContent: 'space-evenly', alignItems: 'center', pointerEvents: purchaseLoading ? 'none' : 'auto', opacity: purchaseLoading ? '0.5' : '1' }}>

                                                                                <OverlayTrigger placement="top" overlay={tooltipEdit}>
                                                                                    <div
                                                                                        onClick={(e) => {
                                                                                            handleUpdatePurchaseList(element, e)
                                                                                        }}
                                                                                        className="d-flex align-items-center justify-content-center"
                                                                                        style={{ color: "#0AC947", fontSize: "18px" }}>
                                                                                        <i className="bi bi-pencil-square"></i>
                                                                                    </div>
                                                                                </OverlayTrigger>

                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={tooltipDelete}>
                                                                                    <div
                                                                                        onClick={(e) => {
                                                                                            handleDeletePurchaseList(element, e)
                                                                                        }}
                                                                                        className="d-flex align-items-center justify-content-center"
                                                                                        style={{ color: "#FF0000", fontSize: "18px" }}>
                                                                                        <i className="bi bi-trash"></i>
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </>
                                                :
                                                <tr style={{ fontSize: '13px', backgroundColor: '#fff', }}>
                                                    <td colSpan="7">No data found</td>
                                                </tr>
                                            }
                                        </>
                                    }

                                </tbody>
                            </Table> */}



                            {rows.length > 0 ?
                                <div className='purchase-item-main-container'>
                                    {
                                        rows.map((element, index) => {
                                            return (
                                                <div className='individual-purchase-item-container' key={index}>
                                                    <div className='d-flex' style={{ position: 'absolute', right: '15px', top: '15px', justifyContent: 'space-evenly', alignItems: 'center', pointerEvents: purchaseLoading ? 'none' : 'auto', opacity: purchaseLoading ? '0.5' : '1' }}>
                                                        {/* <i onClick={(e) => { handleUpdatePurchaseList(element, e) }} className="bi bi-pencil-square"></i> */}

                                                        <OverlayTrigger placement="top" overlay={tooltipEdit}>
                                                            <div
                                                                onClick={(e) => {
                                                                    handleUpdatePurchaseList(element, e)
                                                                }}
                                                                className="d-flex align-items-center justify-content-center"
                                                                style={{ color: "#0AC947", fontSize: "18px", cursor: 'pointer', marginRight: '30px' }}>
                                                                <i className="bi bi-pencil-square"></i>
                                                            </div>
                                                        </OverlayTrigger>

                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={tooltipDelete}>
                                                            <div
                                                                onClick={(e) => {
                                                                    handleDeletePurchaseList(element, e)
                                                                }}
                                                                className="d-flex align-items-center justify-content-center"
                                                                style={{ color: "#FF0000", fontSize: "18px", cursor: 'pointer' }}>
                                                                <i className="bi bi-trash"></i>
                                                            </div>
                                                        </OverlayTrigger>
                                                    </div>
                                                    <div style={{ display: 'flex', }}>
                                                        <div className='purchase-list-numbering' style={{ width: '10%' }}>
                                                            <p style={{ marginBottom: '5px' }}>{index + 1}.</p>
                                                        </div>
                                                        <div style={{ width: '90%', color: 'black', fontSize: '14px' }}>
                                                            <p style={{ marginBottom: '0px', fontWeight: '600', fontSize: '16px' }}><strong>{element.item_name_chr ? element.item_name_chr : 'NA'}</strong></p>
                                                            {(element.quantity_int || element.quantity_int) && <p style={{ marginBottom: '0px' }}>{element?.quantity_int} X {USDollar.format((element?.estimated_price_float) / (element?.quantity_int))} = {USDollar.format(element?.estimated_price_float)}</p>}
                                                            {element?.purchase_link_chr && <div style={{ display: 'flex', }}>
                                                                <>
                                                                    <a href={element?.purchase_link_chr} target="_blank" rel="noreferrer">
                                                                        <p className='call-sub-titles purchase-item-link' style={{ marginBottom: '5px', overflow: 'hidden', color: 'blue', wordBreak: "break-all", fontWeight: '500' }}>
                                                                            {element?.purchase_link_chr}
                                                                        </p>
                                                                    </a>

                                                                    <OverlayTrigger placement="top" overlay={tooltipCopyTxt}>
                                                                        <div
                                                                            onClick={() => {
                                                                                navigator.clipboard.writeText(`${element?.purchase_link_chr}`);
                                                                                copyToClipboard();
                                                                            }}
                                                                            className="d-flex align-items-center justify-content-center"
                                                                            style={{
                                                                                color: "#0AC947",
                                                                                fontSize: "14px",
                                                                                cursor: "pointer",
                                                                                marginLeft: '10px'
                                                                            }}>
                                                                            <i className="bi bi-files"></i>
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                </>
                                                            </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                        {
                                                            (new Date(element?.updated_date_dtm * 1000)).toLocaleString('en-US', {
                                                                month: 'long',
                                                                day: 'numeric',
                                                                year: 'numeric',
                                                                hour: 'numeric',
                                                                minute: '2-digit',
                                                                hour12: true
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div> :

                                <div style={{ fontSize: '16px', textAlign: 'center', margin: '15px 0px', fontWeight: '600' }}>
                                    No data found
                                </div>
                            }


                            {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0px' }}>
                                <PrimaryButton
                                    buttonName={"Add Shopping Item"}
                                    onClick={() => handleCreatePurchaseList()}
                                />
                            </div> */}
                        </> :
                        (toggleForPurchase === 2 || toggleForPurchase === 3) ? <>
                            <div>

                                {/* <form onSubmit={(e) => handleSubmitPurchase(e)} > */}
                                <InputField
                                    labelName={"Item Name"}
                                    placeholderName={"Item Name"}
                                    value={itemName}
                                    onChange={handleItemName}
                                    onBlur={handleItemNameBlurCheck}
                                    errorOccured={itemNameErr}
                                    errorMeesage={"Please add item name"}
                                />

                                <InputField
                                    labelName={"Quantity"}
                                    placeholderName={"Quantity"}
                                    value={quantity || ''}
                                    onChange={handleQuantity}
                                    onBlur={() => {}}
                                // onBlur={handleQuantityBlurCheck}
                                // errorOccured={quantityErr}
                                // errorMeesage={"Please add quantity"}
                                />

                                <InputField
                                    labelName={"Cost Per Item"}
                                    placeholderName={"Cost Per Item"}
                                    value={totalEstimatedCost || ''}
                                    onChange={handleTotalEstimatedCost}
                                    onBlur={() => {}}
                                // onBlur={handleTotalEstimatedCostBlurCheck}
                                // errorOccured={totalEstimatedCostErr}
                                // errorMeesage={"Please add total estimated cost"}
                                />

                                <InputField
                                    labelName={"Website or Location"}
                                    placeholderName={"Website or Location"}
                                    value={purchaseLink}
                                    onChange={handlePurchaseLink}
                                    onBlur={() => {}}
                                // onBlur={handlePurchaseLinkBlurCheck}
                                // errorOccured={purchaseLinkErr}
                                // errorMeesage={"Please add purchase link"}
                                />

                                <TextArea
                                    labelName={"Item Description"}
                                    placeholder={"Item Description"}
                                    value={itemDescription}
                                    onChange={handleDescription}
                                    onBlur={() => {}}
                                // onBlur={handleDescriptionBlurCheck}
                                // errorOccured={itemDescriptionErr}
                                // errorMessage={'Please add description'}
                                />

                                <p style={{ marginBottom: '5px', fontSize: '14px', fontWeight: '600', color: 'black' }}>Total Estimated Cost : {USDollar.format((quantity * totalEstimatedCost).toFixed(2))}</p>

                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {/* <PrimaryButton
                                        buttonName={"Cancel"}
                                        style={{ marginRight: '10px' }}
                                        onClick={(e) => handleCloseCreatePurchaseItem(e)}
                                    /> */}

                                    {toggleForPurchase === 2 && <PrimaryButton
                                        buttonName={"Submit"}
                                        onClick={(e) => handleSubmitPurchase(e)}
                                        loadingMessage={"Loading..."}
                                        isLoading={purchaseLoading}
                                    />}

                                    {toggleForPurchase === 3 && <PrimaryButton
                                        buttonName={"Submit"}
                                        onClick={(e) => handleUpdatePurchase(e)}
                                        loadingMessage={"Loading..."}
                                        isLoading={purchaseLoading}
                                    />}

                                </div>


                                {/* </form> */}

                            </div>
                        </> :
                            toggleForPurchase === 4 ?
                                <>
                                    <div>
                                        <p style={{ fontSize: '16px', fontWeight: '500', color: 'black', textAlign: 'center' }}>{"Enter a email or mobile number and we will send shopping list."}</p>

                                        <form onSubmit={(e) => handleSendPurchaseList(e)}>
                                            <EmailPhoneCombine
                                                inputValue={emailPhoneValue}
                                                handleChangeCode={handleDropdownValue}
                                                handleInputValue={handleEmailPhone}
                                                isEnteringNumber={isPhone}
                                                setIsEnteringNumber={setIsPhone}
                                                errorOccured={isEmailPhoneVal}
                                                errorMessage={validEmail_OR_MobileNumberText}
                                                handleOnBlur={handleEmailPhoneBlur}
                                                defaultCodeValue={codeValue}
                                            />

                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {/* <PrimaryButton
                                                buttonName={"Cancel"}
                                                style={{ marginRight: '10px' }}
                                                onClick={(e) => handleCloseCreatePurchaseItem(e)}
                                            /> */}

                                                <PrimaryButton
                                                    buttonName={"Submit"}
                                                    onClick={(e) => handleSendPurchaseList(e)}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={purchaseLoading}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </> :
                                toggleForPurchase === 5 ?
                                    <div>
                                        <div className='callDetailsRows'>
                                            <p className='call-titles' >{"Item Name"}</p>
                                            <p className='call-sub-titles'>{itemName}</p>
                                        </div>

                                        <div className='callDetailsRows'>
                                            <p className='call-titles' >{"Quantity"}</p>
                                            <p className='call-sub-titles'>{quantity}</p>
                                        </div>

                                        <div className='callDetailsRows'>
                                            <p className='call-titles' >{"Total Estimated Cost"}</p>
                                            <p className='call-sub-titles'>{totalEstimatedCost}</p>
                                        </div>

                                        <div className='callDetailsRows'>
                                            <p className='call-titles' >{"Purchase Link"}</p>

                                            <div style={{ display: 'flex', alignItem: 'center' }}>
                                                <a href={purchaseLink} target="_blank" rel="noreferrer" >
                                                    <p className='call-sub-titles purchase-item-link' style={{ wordBreak: 'break-all', color: 'blue', fontWeight: '500' }}>{purchaseLink}</p>
                                                </a>

                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{ justifyContent: "space-around" }}>
                                                    <OverlayTrigger placement="top" overlay={tooltipCopyTxt}>
                                                        <div
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(`${purchaseLink}`);
                                                                copyToClipboard();
                                                            }}
                                                            className="d-flex align-items-center justify-content-center"
                                                            style={{
                                                                color: "#0AC947",
                                                                fontSize: "14px",
                                                                cursor: "pointer",
                                                                marginLeft: '10px'
                                                            }}>
                                                            <i className="bi bi-files"></i>
                                                        </div>
                                                    </OverlayTrigger>


                                                </div>
                                            </div>

                                        </div>

                                        <div className='callDetailsRows'>
                                            <p className='call-titles' >{"Item Description"}</p>
                                            <p className='call-sub-titles'>{itemDescription}</p>
                                        </div>
                                    </div>
                                    : ''
                    }

                </Modal.Body>
            </Modal>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

        </>
    )
}

export default PurchaseList;